/**
 * RSVP form builder <-> the shared music picker (music-picker.js).
 *
 * The value lives in builderOptions.backgroundMusic, outside the DOM, so
 * collectFormData() never reads or resets it. Every change is a click or an
 * upload, which fires no input/change event on a builder field, so it has to
 * call noteEdit() itself or it would never autosave.
 */
(function () {
    'use strict';

    var picker = null;
    var waitingForAuth = false;

    function options() { return window.builderCore && window.builderCore.builderOptions; }

    function upload(file, contentType) {
        var storage = window.firebaseStorage || (window.firebase && firebase.storage && firebase.storage());
        if (!storage) return Promise.reject(new Error('Storage not ready'));
        var o = options() || {};
        var formId = o.formId || ('temp_' + Date.now());
        var safe = String(file.name || 'song').replace(/[^a-zA-Z0-9.-]/g, '_').slice(-80);
        var ref = storage.ref('form-images/' + formId + '/music_' + Date.now() + '_' + safe);
        // Explicit type: Windows reports .m4a as '' or audio/x-m4a, and the
        // Storage rules accept only the types every browser can play.
        return ref.put(file, { contentType: contentType, cacheControl: 'public, max-age=31536000' })
            .then(function (snap) { return snap.ref.getDownloadURL(); });
    }

    function ensureSignedIn(retry) {
        var user = window.firebaseAuth && window.firebaseAuth.currentUser;
        if (user) return true;
        if (window.authManager && window.authManager.showAuthModal) window.authManager.showAuthModal('upload your song');
        else if (window.showAuthModal) window.showAuthModal('login');
        // Replay the pick once they are in, like the image uploads do.
        var auth = window.firebaseAuth;
        if (auth && auth.onAuthStateChanged && typeof retry === 'function' && !waitingForAuth) {
            waitingForAuth = true;
            var off = auth.onAuthStateChanged(function (u) {
                if (!u) return;
                off();
                waitingForAuth = false;
                setTimeout(retry, 400);
            });
        }
        return false;
    }

    function onChange(value) {
        var o = options();
        if (!o) return;
        o.backgroundMusic = value;
        if (window.formSaveControl && window.formSaveControl.noteEdit) window.formSaveControl.noteEdit();
        if (window.builderCore) window.builderCore.previewNeedsUpdate = true;
        if (typeof window.schedulePreviewUpdate === 'function') window.schedulePreviewUpdate('create', null, true);
        else if (typeof window.debouncedPreviewUpdate === 'function') window.debouncedPreviewUpdate('create', null, true);
    }

    // Back from the song generator's Stripe checkout (?songProject=&song=paid|cancelled):
    // reopen the song once the host's sign-in has been restored, then tidy the URL.
    function resumeSongFromCheckout(openSong) {
        var q = new URLSearchParams(location.search);
        var id = q.get('songProject');
        var paid = q.get('song') === 'paid';
        if (!id || typeof openSong !== 'function') return;
        var tries = 0;
        (function wait() {
            if (window.firebaseAuth && window.firebaseAuth.currentUser) {
                q.delete('songProject'); q.delete('song');
                var rest = q.toString();
                history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
                openSong(id, paid);
            } else if (++tries < 40) setTimeout(wait, 250);
        })();
    }

    function init() {
        var mountEl = document.getElementById('backgroundMusicMount');
        if (!mountEl || !window.QRMusicPicker || picker) return;
        var o = options() || {};
        picker = window.QRMusicPicker.mount(mountEl, {
            value: o.backgroundMusic || null,
            lang: window.BUILDER_LANGUAGE || document.documentElement.lang,
            onChange: onChange,
            envelopeTip: function () { var c = document.getElementById('enableEnvelope'); return !!c && !c.checked; },
            songCreator: function () { var o = options() || {}; return { type: 'form', targetId: o.formId || null }; },
            upload: upload,
            ensureSignedIn: ensureSignedIn
        });
        resumeSongFromCheckout(picker && picker.openSong);
    }

    window.builderMusic = {
        /** Repaint from builderOptions (the loader calls this after a saved form loads). */
        refresh: function () {
            if (!picker) init();
            var o = options();
            if (picker && o) picker.setValue(o.backgroundMusic || null);
        }
    };

    // Keep the envelope tip in step with the envelope switch.
    document.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'enableEnvelope' && picker && picker.refresh) picker.refresh();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
